export class ContasPagarUtil {

    private static montarData(ano: number, mes: number, dia: number): Date {
        const diasNoMes = new Date(ano, mes, 0).getDate();
        return new Date(ano, mes - 1, Math.min(dia, diasNoMes), 0, 0, 0, 0);
    }

    private static avancarMes(ref: { ano: number; mes: number }): void {
        ref.mes++;
        if (ref.mes > 12) { ref.mes = 1; ref.ano++; }
    }

    /**
     * Retorna o primeiro dia do mês da fatura destino — mês mínimo aceito
     * pelo datepicker quando a conta é cartão de crédito.
     */
    static calcularMesFaturaDestino(dataCompetencia: Date, diaFechamento: number, diaVencimento: number): Date {
        const ref = { ano: dataCompetencia.getFullYear(), mes: dataCompetencia.getMonth() + 1 };
        if (dataCompetencia.getDate() > diaFechamento) ContasPagarUtil.avancarMes(ref);
        const venc = { ano: ref.ano, mes: ref.mes };
        if (diaVencimento <= diaFechamento) ContasPagarUtil.avancarMes(venc);
        const d = ContasPagarUtil.montarData(venc.ano, venc.mes, diaVencimento);
        return new Date(d.getFullYear(), d.getMonth(), 1, 0, 0, 0, 0);
    }

    /**
     * Ajusta uma data para que o dia seja o diaVencimento do cartão,
     * mantendo mês e ano.
     */
    static ajustarParaDiaVencimento(dataReferencia: Date, diaVencimento: number): Date {
        return ContasPagarUtil.montarData(
            dataReferencia.getFullYear(), dataReferencia.getMonth() + 1, diaVencimento
        );
    }

    /**
     * Converte string ISO para Date local sem deslocamento de fuso horário.
     * Evita que "2026-06-18T00:00:00Z" vire 17/06 em UTC-3.
     */
    static parseDateLocal(isoString: string): Date {
        const [y, m, d] = isoString.substring(0, 10).split('-').map(Number);
        return new Date(y, m - 1, d, 0, 0, 0, 0);
    }
}
